// extracted by mini-css-extract-plugin
export default {"cardsHeader":"listOfParts_cardsHeader__h+NP5","cardsContainer":"listOfParts_cardsContainer__uPyfk"};